import CompositeArrayNodeBase from '../../../../framework/oop/composite/CompositeArrayNodeBase';

import DatasetsLayoutNode from './DatasetsLayoutNode';
import DatasetsLayoutNodeVisitor from './DatasetsLayoutNodeVisitor';

/**
 * An element of a layout elements tree that represents an array of tabs with
 * each child element being a contend of a tab sheet.
 */
class TabsLayoutNode
  extends CompositeArrayNodeBase<DatasetsLayoutNode>
  implements DatasetsLayoutNode
{
  public acceptVisitor(visitor: DatasetsLayoutNodeVisitor): void {
    visitor.visitTabs(this);
  }
}

export default TabsLayoutNode;
